import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import '../../assets/js/extensions.js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InscriptionComponent } from '../inscription/inscription.component';
import { EncryptDecryptService } from "../services/encrypt-decrypt.service";
import { HereMapComponent } from '../here-map/here-map.component'
import { EventManager, Meta, Title } from '@angular/platform-browser';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Local } from 'protractor/built/driverProviders';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import swal from 'sweetalert2';
import { VariablesGlobales } from '../services/globals.js';
import { param } from 'jquery';
import { ConfigItem, ConfigService } from '../services/config.service';

@Component({
  selector: 'app-annonce-read',
  templateUrl: './annonce-read.component.html',
  styleUrls: ['./annonce-read.component.css']
})
export class AnnonceReadComponent implements OnInit {

  @ViewChild('map')
  private mapComponent: HereMapComponent;

  public annonce: Annonce;
  safeSrc: SafeResourceUrl;
  private base_url: string;
  animal: string;
  name: string;
  public isMobile = false;

  public url = window.location.origin

  oneBlock = true;

  private id: any;
  private src: any;
  private isPost: any;
  private source: any;
  public lat: number;
  public lng: number;

  config = ConfigService.GetItem;

  ngAfterViewChecked() {
    if (window.screen.width >= 768) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
  }



  constructor(private encdec: EncryptDecryptService,
    private eventManager: EventManager,
    private route: ActivatedRoute,
    public router: Router, private http: HttpClient, @Inject('BASE_URL') baseUrl: string,
    public sanitizer: DomSanitizer, public dialog: MatDialog,
    private meta: Meta,
    public title: Title,
    private _sanitizer: DomSanitizer,
    @Inject(Location) public readonly location: Location
  ) {
    this.base_url = baseUrl;
    this.route.queryParams.subscribe(params => {
      this.id = params['id']; // --> Name must match wanted parameter
      this.isPost = params['ispost'];
      if (this.id && !this.isPost)
        this.router.navigate(['/annonce-read', this.id], { queryParams: { source: this.source } });
    });

    if (!this.id)
      this.id = this.route.snapshot.paramMap.get('id');


    if (this.isPost)
      this.openDialog();

    http.get('https://api2.sitederecrutement.com/Home/GetAnnonce?apikey=' + localStorage.getItem('apikey') + '&id=' + this.id, { responseType: "text" }).subscribe(result => {
      if (result.includes('{Error :')) {
        let json = JSON.parse(result);
      }
      else {
        const myDatas = this.encdec.getDecrypt(result);
        const obj = JSON.parse(myDatas.replace('emp_', ''));
        this.annonce = obj;
        if (this.annonce.code_postal && this.annonce.ville)
          http.get('https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=aHtfU0V_4Y-N19VH2R-DpH3vyQwPL8QQdHDiiWD21dw&searchtext=' + this.annonce.adresse1 + ' ' + this.annonce.adresse2 + ' ' + this.annonce.code_postal + ' ' + this.annonce.ville, { responseType: "text" }).subscribe(result => {
            const adress = JSON.parse(result);
            this.lat = adress.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
            this.lng = adress.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
            this.mapComponent.addDomMarker(this.lat, this.lng);
          });

        this.getVideoId(this.annonce.video);

        this.title.setTitle(this.annonce.intitule);
        this.meta.updateTag({ name: 'description', content: "Postuler à nos offres d'emploi et découvrez les bienfaits du chocolat sur votre carrière" });
      }
    }, error => console.error(error));
    this.eventManager.addGlobalEventListener('window', 'resize', this.OnResize.bind(this));
  }

  safeCss(style) {
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }

  private OnResize(event: any) {
    if (window.screen.width >= 768) {
      this.isMobile = false;
    }
    else
      this.isMobile = true;
    //this.mapComponent.resize();
  }

  ngOnInit(): void {
    this.video = 'lCfWLFQXZ8M';
    this.init(this.video);
  }

  isNullOrEmpty(value): boolean {
    return (!value || value === undefined || value === "" || value.length === 0 || value === null);
  }

  public getVideoId(text) {
    if (!(!text || text === undefined || text === "" || text.length === 0 || text === null)) {
      var video_id = '';
      if (text.includes('\''))
        video_id = text.split('embed/')[1].split('\'')[0];
      else
        video_id = text.split('embed/')[1].split('"')[0];
      this.safeSrc = this._sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + video_id);
      //console.log(this.safeSrc);
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(InscriptionComponent, {
      width: '100vw',
      height: '100vh',
      data: { idannonce: this.id, intitule: this.annonce.intitule },
      backdropClass: 'backdropBackground',
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  announcesReturn(): void {
    this.router.navigateByUrl('/annonces');
  }
  getMulti(text: string): string {
    if ((text.match(/;/g) || []).length > 1)
      return 's';
    return '';
  }

  public YT: any;
  public video: any;
  public player: any;
  public reframed: boolean = false;

  init(text) {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.body;
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window['onYouTubeIframeAPIReady'] = () => this.startVideo();
  }

  startVideo() {
    this.reframed = false;
    this.player = new window['YT'].Player('player', {
      videoId: this.video,
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
        controls: 1,
        disablekb: 1,
        rel: 0,
        showinfo: 0,
        fs: 0,
        playsinline: 1
      },
      events: {
        'onStateChange': this.onPlayerStateChange.bind(this),
        'onError': this.onPlayerError.bind(this),
        'onReady': this.onPlayerReady.bind(this),
      }
    });
  }

  onPlayerStateChange(event) {
    switch (event.data) {

      case window['YT'].PlayerState.PLAYING:
        if (this.cleanTime() == 0) {
          //console.log('started ' + this.cleanTime());
        }
        break;
    }
  }

  cleanTime() {
    return Math.round(this.player.getCurrentTime());
  }

  onPlayerReady(event) {
    event.target.playVideo();
  }

  onPlayerError(event) {
    switch (event.data) {
      case 2:
        //console.log('' + this.video);
        break;
      case 100:
        break;
      case 101 || 150:
        break;
    }
  }

  facebookShare() {
    event.preventDefault();
    let newwindow = window.open("https://www.facebook.com/dialog/share?app_id=2585236741774172&href=" + this.base_url + '/api/wa7ER8iCfM6Vzrgb97PB3Ubs6Ah4Z895/' + this.annonce.idannonce, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  twitterShare() {
    event.preventDefault();
    let newwindow = window.open("https://twitter.com/intent/tweet?text=" + this.config("social_twitter")?.param1 + "&url=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  tumblrShare() {
    event.preventDefault();
    let newwindow = window.open("https://www.tumblr.com/widgets/share/tool/preview?canonicalUrl=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  pinterestShare() {
    event.preventDefault();
    let newwindow = window.open("https://www.pinterest.fr/pin/create/button/?description=Découvrez%20les%20offres%20de%20stage,%20alternance,%20CDD,%20CDI%20de%20Cerfrance%20Seine%20Normandie.%20Postulez%20en%20ligne%20dès%20maintenant%20!&media=&url=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  linkedinShare() {
    event.preventDefault();
    let newwindow = window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + this.base_url + 'api/wa7ER8iCfM6Vzrgb97PB3Ubs6Ah4Z895/' + this.annonce.idannonce, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  bloggerShare() {
    event.preventDefault();
    let newwindow = window.open("https://www.blogger.com/blog-this.g?n=Cerfrance Seine Normandie Recrutement&t=Découvrez les offres de stage, alternance, CDD, CDI de Cerfrance Seine Normandie. Postulez en ligne dès maintenant !&u=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  skypeShare() {
    event.preventDefault();
    let newwindow = window.open("https://web.skype.com/share?title=Cerfrance Seine Normandie Recrutement&url=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  wordpressShare() {
    event.preventDefault();
    let newwindow = window.open("https://wordpress.com/wp-admin/press-this.php?t=Cerfrance Seine Normandie Recrutement&u=" + location.href, 'name', 'height=500,width=520,top=200,left=300,resizable');
    if (window.focus) {
      newwindow.focus()
    }
  }

  openDialogSend(): void {
    event.preventDefault();
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '60rem',
      data: {
        idannonce: this.annonce.idannonce,
        corps: "Bonjour,\r\nUn(e) de vos ami(e) a souhaité vous envoyer une offre d'emploi ou de stage de :\r\nposte: " + this.annonce.intitule + "\r\naccès à l'offre en cliquant sur le lien suivant :\r\n" + location.href + "\r\nVoici le message de votre ami(e):\r\nJ'ai trouvé cette offre qui peut t'intéresser. ",
        obj: "Un(e) ami(e) vous envoie cette offre d'emploi"
      },
      panelClass: 'custom-modalbox'
    });

    dialogRef.afterClosed().subscribe(resulta => {
      if (resulta) {
        const userInfo: Mail = {
          from: 'admin-ariane12@rhprofiler.com',
          to: resulta.email,
          corps: resulta.corps,
          subject: resulta.obj,
          sms: resulta.sms
        }
        let data = this.encdec.getEncrypt(JSON.stringify(userInfo));
        const formData = new FormData();
        formData.append('datas', data);
        this.http.post('https://api2.sitederecrutement.com/Home/sendfriend?apikey=' + localStorage.getItem('apikey'), formData, { responseType: "text" }).subscribe(
          (result) => {
            if (this.encdec.getDecrypt(result) !== 'null') {
              let resultb = new Result(this.encdec.getDecrypt(result));
              //console.log(resultb);
              if (resultb.result) {
                swal.fire({
                  title: "Bravo !",
                  text: "Vous avez bien envoyé l'annonce !",
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "btn btn-rose",
                  },
                  icon: "success",
                  iconColor: 'd '
                });
              } else {
                swal.fire({
                  title: "Erreur !",
                  text: "Votre partage a rencontré un problème.",
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "btn btn-danger",
                  },
                  icon: "error"
                });
              }
            }
          }
        )
      }
    });
  }

  print(): void {
    event.preventDefault();
    const printTitle = document.getElementById("title");
    const printContent = document.getElementById("printId");
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printTitle.innerHTML + printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    //WindowPrt.close();
  }
}

export class Result {
  constructor(public result: string) { }
}

export interface DialogData {
  idannonce: number;
  email: string;
  obj: string;
  corps: string;
  sms: string;
}

@Component({
  selector: 'dialog-send',
  templateUrl: 'dialog-send.html'
})
export class DialogOverviewExampleDialog {

  public idannonce: number;
  public _email: string = '';
  public _sms: string = '';
  public obj: string;
  public corps: string;
  config = ConfigService.GetItem;

  public controlForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public param: VariablesGlobales) {

    this.controlForm = new FormGroup({
      sms: new FormControl(this._sms, [
        Validators.required,
        Validators.pattern('(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}')
      ]),
      email: new FormControl(this._email, [
        Validators.required,
        Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))')
      ]),
    });

    this.idannonce = data.idannonce;
    this.obj = data.obj;
    this.corps = data.corps;
  }

  get sms() { return this.controlForm.get('sms'); }

  get email() { return this.controlForm.get('email'); }

  optionnal() {
    if (this.sms.valid)
      this.controlForm.controls['email'].validator = Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))');
    else
      this.controlForm.controls['email'].validator =
        Validators.compose([Validators.pattern('(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))'), Validators.required]);

    if (this.email.valid)
      this.controlForm.controls['sms'].validator = Validators.pattern('(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}');
    else
      this.controlForm.controls['sms'].validator =
        Validators.compose([Validators.pattern('(0|\\+33)[1-9]([-. ]?[0-9]{2}){4}'), Validators.required]);

    this.controlForm.controls['email'].updateValueAndValidity();
    this.controlForm.controls['sms'].updateValueAndValidity();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onClick(): void {
    this.dialogRef.close({
      idannonce: this.data.idannonce,
      email: this.email.value,
      corps: this.corps,
      obj: this.obj,
      sms: this.sms.value
    });
  }

}

interface Mail {
  from: string;
  to: string;
  subject: string;
  corps: string;
  sms: string;
}

interface Annonce {
  idannonce: number;
  intitule: string;
  lieu: string;
  type: string;
  pres_entreprise: string;
  caract_poste: string;
  video: string;
  profil: string;
  precision: string;
  ref: string;
  experience: string;
  expBas: string;
  experienceHaut: string;
  nombre_postes: number;
  statut: string;
  salaireBas: string;
  salaireHaut: string;
  cp: string;
  ville: string;
  adresse: string;
  debut: string;
  fin: string;
  societe: string;
  code_postal: string;
  societe_logo: string;
  adresse1: string;
  adresse2: string;
  autre_caract: string;
  contact_precision: string;
  contrats: string;
  regions: string;
  date_embauche: string;
  debut_diffusion: Date;
  fonction: string;
  salaire: string;
}
